require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-diabetic-neuropathy.json") })
        }
      }, "path---post-diabetic-neuropathy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-diabetic-neuropathy!./.cache/json/post-diabetic-neuropathy.json
// module id = 351
// module chunks = 231608221292675